import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="Home">
      <section className="hero">
        <div className="hero__inner">
          <span className="hero__badge">NFT · Community · Rides</span>
          <h1 className="hero__title">
            Ride. Mint.<br />Compete.
          </h1>
          <p className="hero__subtitle">
            Cyclin is where bikers mint and trade NFTs, join the community, and compete worldwide.
          </p>
          <div className="hero__actions">
            <Link to="/Minter" className="btn btn--primary">Mint your NFT</Link>
            <Link to="/project" className="btn btn--secondary">Our ambition</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
